
var React = require("react");
var ActionButton = require("../generic/ActionButton.jsx");
var DataActionUtil = require("../../../util/DataActionUtil.js");

class DeleteInfoButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
        var removed = this.props.current_user_id !== this.props.resource.user_id;
       
        return <React.Fragment>
            { !removed && <div className="infoLibrary__options__separator"></div> }
            <ActionButton 
                    {...this.props}
                    removeDisable={removed}
                    text="Delete"
                    mainClass="delete"
                    action={DataActionUtil.deleteAsset}
               />
        </React.Fragment>
    }
}

module.exports = DeleteInfoButton;